module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("DFP Setup for " + _vm._s(_vm.networkName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-body"
  }, [_c('el-button', {
    attrs: {
      "title": (_vm.hbAdvCreated) ? 'advertiser and placement already created' : 'create advertiser and placement',
      "disabled": _vm.hbAdvCreated,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createAdvAndPlacement()
      }
    }
  }, [_vm._v("\n        Create advertiser, placement and mod key with values "), (_vm.creatingAdvertiser) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('h5', [_vm._v("Select Bidders")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "display": "flex",
      "flex-flow": "row wrap"
    }
  }, _vm._l((_vm.bidders), function(bidder) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px"
      },
      attrs: {
        "span": 4
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "left",
        "position": "relative"
      }
    }, [_c('el-button', {
      key: bidder.id,
      attrs: {
        "label": bidder.id,
        "title": (_vm.current_active_bidders.indexOf(bidder.id) > -1 || _vm.current_started_bidders.indexOf(bidder.id) > -1) ? 'DFP setup is already complete' : 'select bidder',
        "disabled": !_vm.hbAdvCreated || (_vm.current_active_bidders.indexOf(bidder.id) > -1 || _vm.current_started_bidders.indexOf(bidder.id) > -1),
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.initiateSetup(bidder)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(bidder.name) + " "), (_vm.current_started_bidders.indexOf(bidder.id) > -1) ? _c('i', {
      staticClass: "el-icon-loading"
    }) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "el-icon-refresh",
      staticStyle: {
        "position": "absolute",
        "top": "50%",
        "transform": "translateY(-50%)",
        "margin-left": "5px",
        "cursor": "pointer"
      },
      attrs: {
        "title": "retry failed line item create associations"
      },
      on: {
        "click": function($event) {
          return _vm.retryLicas(bidder)
        }
      }
    })], 1)])
  }), 1), _vm._v(" "), _c('h5', [_vm._v("Select Currency")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.currencyChanged
    },
    model: {
      value: (_vm.dfp.prebid_currency),
      callback: function($$v) {
        _vm.$set(_vm.dfp, "prebid_currency", $$v)
      },
      expression: "dfp.prebid_currency"
    }
  }, _vm._l((_vm.currenciesOptions), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option.code,
        "value": option.id
      }
    })
  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-button', {
    staticClass: "el-button el-button--info",
    attrs: {
      "disabled": !_vm.isComplete || _vm.hbSetupInitiated,
      "title": _vm.hbSetupInitiated ? 'Header Bidding Setup is running' : ''
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus el-icon-left"
  }), _vm._v("\n            Submit\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--danger",
    attrs: {
      "to": "/admin/dfp-settings/"
    }
  }, [_vm._v("\n            Cancel\n            ")])], 1), _vm._v(" "), _c('hr')])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4226406a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dfp/EditDfp.vue
// module id = 677
// module chunks = 2